import { createReducer } from '@reduxjs/toolkit';
import { close, closeAll, dismiss, error, success, warning, } from '@innovyze/stylovyze/lib/actions/notifications.actions';
export const initialState = [];
const reducer = {
    [warning.toString()]: (state, action) => [...state, action.payload],
    [success.toString()]: (state, action) => [...state, action.payload],
    [error.toString()]: (state, action) => [...state, action.payload],
    [dismiss.toString()]: (state, action) => state.map(notification => notification.key === action.payload
        ? { ...notification, dismissed: true }
        : notification),
    [close.toString()]: (state, action) => state.filter(notification => notification.key !== action.payload),
    [closeAll.toString()]: () => [],
};
export default createReducer(initialState, reducer);
